export interface ParsedDuration {
  hours: number;
  minutes: number;
  seconds: number;
  totalSeconds: number;
}

export const parseDuration = (input: string): ParsedDuration | null => {
  const trimmed = input.trim();
  if (!trimmed) return null;

  const parts = trimmed
    .split(/[:.]/)
    .map((part) => {
      const trimmedPart = part.trim();
      const value = parseInt(trimmedPart, 10);
      return {
        value: Number.isNaN(value) ? 0 : value,
        length: trimmedPart.length,
        isValid:
          trimmedPart.length === 0 || !Number.isNaN(parseInt(trimmedPart, 10)),
      };
    })
    .filter((p) => p.isValid);

  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  switch (parts.length) {
    case 1:
      hours = parts[0].value;
      break;
    case 2:
      hours = parts[0].value;
      minutes = parts[1].value;
      break;
    case 3:
      hours = parts[0].value;
      minutes = parts[1].value;
      seconds = parts[2].value;
      break;
    default:
      return null;
  }

  if (seconds >= 60) {
    minutes += Math.floor(seconds / 60);
    seconds %= 60;
  }
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes %= 60;
  }

  if (hours > 999) {
    hours = 999;
    minutes = 0;
    seconds = 0;
  }

  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  return { hours, minutes, seconds, totalSeconds };
};
